import { render, staticRenderFns } from "./IlmoittautuminenHallitusParticipant.vue?vue&type=template&id=5f4583bf&scoped=true"
import script from "./IlmoittautuminenHallitusParticipant.vue?vue&type=script&lang=js"
export * from "./IlmoittautuminenHallitusParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4583bf",
  null
  
)

export default component.exports